module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "title": _vm.title,
      "visible": _vm.visible,
      "append-to-body": "",
      "width": "70%"
    },
    on: {
      "close": _vm.handleClose
    }
  }, [_vm._l((_vm.SettingsList), function(item, index) {
    return _c('div', {
      key: index,
      staticStyle: {
        "display": "flex",
        "align-items": "center",
        "margin-bottom": "30px"
      }
    }, [_c('div', {
      staticStyle: {
        "font-weight": "bold",
        "margin-right": "10px",
        "margin-bottom": "5px"
      }
    }, [_vm._v("\n      " + _vm._s(item.label) + "\n    ")]), _vm._v(" "), _c('el-radio-group', {
      model: {
        value: (_vm.SettingsValue[item.value].all),
        callback: function($$v) {
          _vm.$set(_vm.SettingsValue[item.value], "all", $$v)
        },
        expression: "SettingsValue[item.value].all"
      }
    }, [_c('el-radio', {
      attrs: {
        "label": false
      }
    }, [_vm._v("所有人")]), _vm._v(" "), _c('el-radio', {
      attrs: {
        "label": true
      }
    }, [_vm._v("指定角色/人")])], 1), _vm._v(" "), _c('div', {
      staticStyle: {
        "margin-left": "20px"
      }
    }, [_c('div', _vm._l((_vm.SettingsValue[item.value]
      .specialCaseList), function(specialItem, specialIndex) {
      return _c('div', {
        key: specialIndex,
        staticStyle: {
          "display": "inline-block",
          "margin-right": "10px"
        }
      }, [_c('el-tag', {
        attrs: {
          "closable": ""
        },
        on: {
          "close": function($event) {
            _vm.SettingsValue[item.value].specialCaseList.splice(
              specialIndex,
              1
            )
          }
        }
      }, [_vm._v(_vm._s(specialItem.name))])], 1)
    }), 0), _vm._v(" "), (_vm.SettingsValue[item.value].all) ? _c('el-button', {
      attrs: {
        "type": "text",
        "size": "default"
      },
      on: {
        "click": function($event) {
          return _vm.handleSpecialCaseSetting(_vm.SettingsValue[item.value])
        }
      }
    }, [_vm._v("选择")]) : _vm._e()], 1)], 1)
  }), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.handleClose
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    },
    on: {
      "click": _vm.handleConfirm
    }
  }, [_vm._v("确 定")])], 1)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8af84dcc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/developerInfo/components/permissionSettings.vue
// module id = 2420
// module chunks = 68